import React from 'react';
import MarkDetail from 'components/Tvendo/Article/DataMaster/Mark/Detail/MarkDetail';

export default function () {
  return <MarkDetail />;
}
